// extracted by mini-css-extract-plugin
export default {"root":"Footer__root--3o2fx","root_absolute":"Footer__root_absolute--29XlQ","root_withMargins":"Footer__root_withMargins--2RXl1"};